import throttle from 'lodash.throttle';
import g from '#core/global';
import load from '#core/load';
import layout from '#core/layout';
import util from '#core/util';
import masthead from '#partial/masthead/masthead';
import expandable from '#partial/expandable/expandable';


const state = window.teal_state = window.teal_state || {};

const is_active_attr = 'data-is-active';
const is_expanded_$ = '[aria-expanded="true"]';
const jump_nav_toggle_$ = '.jump-nav__toggle';
const jump_select_$ = '.jump-select select';
const jump_selector_attr = 'data-jump-selector';
const jump_target_attr = 'data-jump-target';
const persistent_marker_attr = 'data-jump-persistent'; // TODO: make this work, where it sets top_only to true if persistent is true
const any_link_$ = 'a';
const href_attr = 'href';
const use_firefox_workaround = true;
const margin_top_minimum = 150;
const desktop_breakpoint = 'b4';

// const jump_anchor_slug_attr = 'data-jump-anchor-slug';
// const jump_anchor_name_attr = 'data-jump-anchor-name';
const true_s = 'true';
const false_s = 'false';

let has_jump = false;
let is_jumping = false;
let $jump_toggles = [];
let $jump_selects = [];
let $jump_links = [];
let $jump_targets = [];
let scroll_timeout = null;
let persistent_marker = false;


const module = {
	jump_selector_attr: jump_selector_attr,
	
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('jump')) return false;
		
		load.content(() => {
			
			// We don't need (or want) to do this, because jump_selector_attr is the
			// default attribute that will be used when converting links to same-page
			// destinations when no other matching selectors have identified the
			// target pattern
			// hash.setLinkAttribute('*', jump_selector_attr);
			
			has_jump = assign_elements();
			if (!has_jump) return false;
			
			check_mobile_nav();
		});
		load.all(() => {
			has_jump = assign_elements();
			if (!has_jump) return false;
			
			mark_targets();
			assign_scroll_events();
			assign_resize_events();
			
			setTimeout(() => {
				activate_from_url();
			}, 100);
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_jump) return true;

	$jump_toggles = document.querySelectorAll(jump_nav_toggle_$);
	$jump_selects = document.querySelectorAll(jump_select_$);
	$jump_links = document.querySelectorAll(`[${jump_selector_attr}]`);
	// if (!$jump_selects.length && !$jump_links.length) return false;
	// $jump_targets = document.querySelectorAll(`[${jump_anchor_name_attr}]`);
	
	$jump_selects.forEach($jump_select => {
		$jump_select.addEventListener(g.change_e, e => {
			jump(e);
		});
	});
	
	document.addEventListener(g.click_e, e => {
		jump(e);
	});
	
	return true;
}


/**
 * Assign scroll events
 */
function assign_scroll_events() {
	if (!$jump_targets.length) return false;
	
	window.addEventListener(g.scroll_e, throttle(() => {
		update_jump_nav();
	}, 250));
}


/**
 * Assign resize events
 */
function assign_resize_events() {
	const resize_callbacks = [
		check_mobile_nav,
	];
	resize_callbacks.forEach(callback => callback());
	
	window.addEventListener(g.resize_e, throttle(() => {
		resize_callbacks.forEach(callback => callback());
	}, 150));
}


/**
 * Update active jump nav item on scroll
 * @param {boolean} deactivate
 */
function update_jump_nav(deactivate = false) {
	if (is_jumping && !deactivate) return false;
	
	let $active_target = null;
	let target_$ = null;
	
	// If not explicitly deactivating all links, find the last target in view
	if (!deactivate) {
		$jump_targets.forEach(($target, index) => {
			const is_intersecting = layout.isIntersecting({
				$element: $target,
				lookaround: parseFloat(0.4),
				// ...(persistent_marker && {top_only: true}),
				top_only: true,
			});
			if (!is_intersecting) return false;
			
			$active_target = $target;
			target_$ = $active_target.getAttribute(jump_target_attr);
		});
	}
	
	// Deactivate existing active links
	const previous_active_link_$ = `[${jump_selector_attr}]`
		+ `:not([${jump_selector_attr}="${target_$}"])`
		+ `[${is_active_attr}="${true_s}"]`;
	const $previous_active_links = document.querySelectorAll(previous_active_link_$);
	$previous_active_links.forEach($link => {
		$link.setAttribute(is_active_attr, false_s);
	});
	
	if (!$active_target) return false;
	
	// Activate matching link
	const new_active_link_$ = `[${jump_selector_attr}="${target_$}"]`
		+ `:not([${is_active_attr}="${true_s}"])`;
	const $new_active_link = document.querySelector(new_active_link_$);
	if (!$new_active_link) return false;
	
	$new_active_link.setAttribute(is_active_attr, true_s);
}


/**
 * Jump to target
 * @param {event} e
 */
function jump(e) {
	let $source = e.target;
	const is_select = $source.matches(jump_select_$);
	if (!is_select) {
		$source = $source.closest(`[${jump_selector_attr}]`);
	}
	if (!$source) return;
	
	const target_$ = (!is_select)
		? $source.getAttribute(jump_selector_attr)
		: $source.value;
	if (!target_$) return false;
	
	e.preventDefault();
	$source.blur();
	
	if (layout.isBreakpointMin(desktop_breakpoint)) {
		const $container = $source.closest(expandable.container_$);
		if ($container) {
			expandable.toggle({
				id: $container.id,
				force: false,
			});
		}
	}
	
	const target_position = (isNaN(target_$))
		? find_target_position(target_$)
		: target_$;
	scroll_to_target(target_position);
	
	// TODO: dismiss all masthead panels
	// Dismiss mobile nav
	const nav_toggle_$ = `${masthead.nav_mobile_toggle_$}${is_expanded_$}`;
	const $nav_toggle = document.querySelector(nav_toggle_$);
	if ($nav_toggle) {
		$nav_toggle.click();
	}
	
	if (is_select) {
		reset($source);
	}
}


/**
 * Find jump target
 * @param {string} selector
 * @return {element}
 */
function find_target(selector) {
	let $target = document.querySelector(selector);
	if (!$target) {
		if (util.isValidSelector(`#${selector}`)) {
			$target = document.querySelector(`#${selector}`);
		}
	}
	return $target;
}


/**
 * Find jump target position
 * @param {string} selector
 * @param {boolean} center_vertically
 * @return {int}
 */
function find_target_position(selector, center_vertically = false) {
	const $target = find_target(selector);
	if (!$target) return -1;
	
	const styles = getComputedStyle($target);
	const margin_top = parseInt(styles.marginTop);
	const position_rect = $target.getBoundingClientRect();
	const position_y = position_rect.top + window.scrollY;
	let top = position_y - Math.max(margin_top, margin_top_minimum);
	
	if (!center_vertically) {
		return Math.round(top);
	}
	
	const height = layout.getHeight($target);
	const target_pos = Math.round(top - ((window.innerHeight - height) / 2));
	return Math.round(target_pos);
}


/**
 * Check URL for target element and scroll
 */
function activate_from_url() {
	const url_hash = window.location.hash.substring(1);
	if (!url_hash.length) return false;
	
	// Remove class selector from URL
	if (url_hash.includes('.')) {
		history.replaceState(null, null, '#');
	}
	
	let target_position = find_target_position(url_hash);
	if (
		!use_firefox_workaround
		&& target_position >= 0
	) {
		scroll_to_target(target_position);
	}
	
	// Firefox seemingly doesn't want to scroll the window on page load, perhaps
	// because it doesn't think the scroll was initiated by the user. This workaround
	// creates a bogus link and simulates clicking the link to trigger scrolling.
	const $link = document.createElement(any_link_$);
	$link.setAttribute(href_attr, '#');
	document.body.appendChild($link);
	setTimeout(() => {
		target_position = find_target_position(url_hash);
		if (target_position < 0) {
			$link.setAttribute(jump_selector_attr, target_position);
			$link.click();
		}
		$link.remove();
	}, 250);
	return true;
}


/**
 * Add attribute to jump targets
 */
function mark_targets() {
	$jump_links.forEach($jump_link => {
		const target_$ = $jump_link.getAttribute(jump_selector_attr);
		if (!util.isValidSelector(target_$)) return false;
		
		const $target = document.querySelector(target_$);
		if (!$target) return false;
		
		$target.setAttribute(jump_target_attr, target_$);
		$jump_targets.push($target);
	});
}


/**
 * Scroll to position
 * @param {int} target_position
 */
function scroll_to_target(target_position) {
	target_position = parseInt(target_position);
	if (target_position < 0) return false;
	
	// is_jumping = true;
	// update_jump_nav(true);
	
	window.scrollTo({
		top: target_position,
		left: 0,
		behavior: 'smooth',
	});
	
	// Don't update jump nav links active state until scrolling is done
	// window.addEventListener(g.scroll_e, function scroll_listener(e) {
	// 	clearTimeout(scroll_timeout);
	// 	scroll_timeout = setTimeout(() => {
	// 		is_jumping = false;
	// 		window.removeEventListener(g.scroll_e, scroll_listener);
	// 		update_jump_nav();
	// 	}, 200);
	// });
}


/**
 * Reset to default option
 * @param {element} $select
 */
function reset($select) {
	$select.selectedIndex = 0;
}


/**
 * Check if nav on mobile should be collapsed
 */
function check_mobile_nav() {
	$jump_toggles.forEach($jump_toggle => {
		const id = $jump_toggle.getAttribute(expandable.target_attr);
		expandable.toggle({
			id: id,
			force: !layout.isBreakpointMin(desktop_breakpoint),
		});
	});
}


/**
 * Check if window width is mobile
 * @return {boolean}
 */
function is_mobile() {
	const window_breakpoint = layout.getBreakpointName(window.innerWidth);
	const breakpoint_width = state.layout.breakpoints[window_breakpoint];
	const desktop_width = state.layout.breakpoints[desktop_breakpoint];
	return breakpoint_width < desktop_width;
}
